<template>
  <div>
    <escalated-client-posts-toolbar
      :client="client"
      v-model:filters="filters"
    />
    <posts-view-options
      v-model:filters="filters"
      v-model:pagination-mode="paginationMode"
    >
      <escalated-client-posts-toolbar
        :client="client"
        v-model:filters="filters"
        :maximize-btn="{flat: true}"
        minimized
      />
    </posts-view-options>

    <posts
      v-if="filters.socialSiteIds.length"
      :filters="filters"
      :persist="paginationMode === 'scroll'"
      :infinite-scroll="paginationMode === 'scroll'"
      :new-page-top="paginationMode === 'manual'"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, PostFilters } from '@/type';
import { status } from '@/social/post/post';
import Posts from '../Posts.vue';
import EscalatedClientPostsToolbar from './EscalatedClientPostsToolbar.vue';
import PostsViewOptions from '../PostsViewOptions.vue';

interface Data {
  filters: PostFilters,
  paginationMode: 'scroll'
}

export default defineComponent({
  components: {
    PostsViewOptions,
    EscalatedClientPostsToolbar,
    Posts,
  },
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  data(): Data {
    return {
      filters: {
        clientIds: [this.client.id],
        statuses: [status.ESCALATED],
        socialSiteIds: [],
        categoryIds: {},
        isTrashed: false,
        since: null,
        until: null,
        order: 'desc',
      },
      paginationMode: 'scroll',
    };
  },
});
</script>
